var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"device-changing-wrapper"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('device-list',{attrs:{"devices":_vm.devices},on:{"select":_vm.onSelect}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }